<script>
  import { Line } from 'vue-chartjs'
  import { mapState } from 'vuex'

  function formatDate (date) {
    const year = date.getFullYear()
    const month = (`${parseInt(date.getMonth()) + 1}`).padStart(2, '0')
    const day = (`${parseInt(date.getDate())}`).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  function setWeekly (date, data, index, col) {
    const eDate = new Date(date)
    const sDate = new Date(date)
    sDate.setDate(sDate.getDate() - 7)
    const ret = []
    for (let tDate = sDate; tDate <= eDate; sDate.setDate(sDate.getDate() + 1)) {
      tDate = sDate
      const cDate = formatDate(tDate)
      const ndata = data.find(e => e[index] === cDate)
      ret.push(ndata === undefined ? 0 : ndata[col])
    }
    return ret
  }

  function setMonthly (date, data, index, col) {
    const eDate = new Date(date)
    const sDate = new Date(date)
    sDate.setMonth(sDate.getMonth() - 1)
    const ret = []
    for (let tDate = sDate; tDate <= eDate; sDate.setDate(sDate.getDate() + 1)) {
      tDate = sDate
      const cDate = formatDate(tDate)
      const ndata = data.find(e => {
        return e[index] === cDate
      })
      ret.push(ndata === undefined ? 0 : ndata[col])
    }
    return ret
  }

  function setYearly (date, data, col) {
    const eDate = new Date(date)
    const sDate = new Date(date)
    sDate.setYear(sDate.getFullYear() - 1)
    const ret = []
    for (let tDate = sDate; tDate <= eDate; sDate.setMonth(sDate.getMonth() + 1)) {
      tDate = sDate
      const ndata = data.find(e => (e.month === parseInt(tDate.getMonth() + 1) && parseInt(tDate.getFullYear()) === e.year))
      ret.push(ndata === undefined ? 0 : ndata[col])
    }
    return ret
  }

  function getWeekly (date) {
    const day = new Date(date)
    const sday = new Date(date)
    sday.setDate(sday.getDate() - 7)
    const weekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
    const ret = []
    for (let tday = sday; tday <= day; sday.setDate(sday.getDate() + 1)) {
      tday = sday
      ret.push(weekDays[tday.getDay()])
    }
    return ret
  }

  function getMonthly (date) {
    const eDate = new Date(date)
    const sDate = new Date(date)
    sDate.setMonth(sDate.getMonth() - 1)
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    const ret = []
    for (let tDate = sDate; tDate <= eDate; sDate.setDate(sDate.getDate() + 1)) {
      tDate = sDate
      ret.push(`${months[tDate.getMonth()]}/${(tDate.getDate() + '').padStart(2, '0')}`)
    }
    return ret
  }

  function getYearly (date) {
    const eDate = new Date(date)
    const sDate = new Date(date)
    sDate.setYear(sDate.getFullYear() - 1)
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    const ret = []
    for (let tDate = sDate; tDate <= eDate; sDate.setMonth(sDate.getMonth() + 1)) {
      tDate = sDate
      ret.push(`${tDate.getFullYear()}-${months[tDate.getMonth()]}`)
    }
    return ret
  }
  let updateChart = null
  export default {
    extends: Line,
    props: {
      graphSetting: Number,
      graphDataSales: Array,
      graphDataPurchases: Array,
      graphDataLosts: Array,
      graphDataLoanTxn: Array,
      graphDataLoanInv: Array,
      graphDataExpense: Array,
      date: String,
    },
    data () {
      return {
        labels: null,
        data: {
          labels: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
          datasets: [
            {
              lineTension: 0.1,
              label: 'Sales',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(108, 185, 111, 0.9)',
              borderColor: 'rgba(37, 63, 38, 0.9)',
              backgroundColor: 'rgba(76, 175, 80, 0.5)',
              borderWidth: 1,
            },
            {
              lineTension: 0.1,
              label: 'Purchase',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(255, 201, 123, 0.9)',
              borderColor: 'rgba(85, 50, 0, 0.9)',
              backgroundColor: 'rgba(255, 152, 0, 0.5)',
              borderWidth: 1,
            },
            {
              lineTension: 0.1,
              label: 'Lost',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(152, 48, 39, 0.9)',
              borderColor: 'rgba(52, 16, 13, 0.9)',
              backgroundColor: 'rgba(156, 50, 40, 0.5)',
              borderWidth: 1,
            },
            {
              lineTension: 0.1,
              label: 'Loan Returns',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(189, 73, 213, 0.9)',
              borderColor: 'rgba(74, 28, 84, 0.9)',
              backgroundColor: 'rgba(224, 86, 253, 0.5)',
              borderWidth: 1,
            },
            {
              lineTension: 0.1,
              label: 'Loan Lent',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(133, 119, 226, 0.9)',
              borderColor: 'rgba(44, 39, 75, 0.9)',
              backgroundColor: 'rgba(72, 52, 212, 0.5)',
              borderWidth: 1,
            },
            {
              lineTension: 0.1,
              label: 'Expenses',
              data: [0, 0, 0, 0, 0, 0, 0],
              pointBackgroundColor: 'rgba(54, 0, 0, 0.9)',
              borderColor: 'rgba(164, 0, 0, 0.9)',
              backgroundColor: 'rgba(247, 0, 0, 0.5)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          legend: {
            labels: {
              fontColor: '#666',
            },
          },
          scales: {
            xAxes: [
              {
                type: 'category',
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      }
    },
    mounted () {
      this.renderChart(this.data, this.options)
      clearTimeout(updateChart)
      updateChart = setTimeout(() => this.setDefaultLabels(), 1000)
    },
    computed: {
      ...mapState({

      }),
    },
    watch: {
      graphDataSales (data) {
        this.updateData()
      },
      graphDataPurchases (val) {
        this.updateData()
      },
      graphDataLosts (val) {
        this.updateData()
      },
      graphDataExpenses (val) {
        this.updateData()
      },
      // graphSetting (val) {
      //   this.updateData()
      // },
      // date (val) {
      //   this.updateData()
      // },
    },
    methods: {
      updateData () {
        clearTimeout(updateChart)
        updateChart = setTimeout(() => this.setData(), 500)
      },
      setData () {
        const graphSetting = this.graphSetting
        if (graphSetting === 0) {
          this.setDataWeekly()
          this.setLabelsWeekly()
        } else if (graphSetting === 1) {
          this.setDataMonthly()
          this.setLabelsMonthly()
        } else if (graphSetting === 2) {
          this.setDataYearly()
          this.setLabelsYearly()
        }
        this.renderChart(this.data, this.options)
      },
      setDefaultLabels () {
        this.data.labels = getWeekly(this.date)
        this.renderChart(this.data, this.options)
      },
      setDataWeekly () {
        this.data.datasets[0].data = setWeekly(this.date, this.graphDataSales, 'date_sold', 'tamount')
        this.data.datasets[1].data = setWeekly(this.date, this.graphDataPurchases, 'date_recieved', 'tamount')
        this.data.datasets[2].data = setWeekly(this.date, this.graphDataLosts, 'date_lost', 'tamount')
        this.data.datasets[3].data = setWeekly(this.date, this.graphDataLoanTxn, 'date_transaction', 'tamount')
        this.data.datasets[4].data = setWeekly(this.date, this.graphDataLoanInv, 'date_loaned', 'tamount')
        this.data.datasets[5].data = setWeekly(this.date, this.graphDataExpense, 'date', 'tamount')
      },
      setDataMonthly () {
        this.data.datasets[0].data = setMonthly(this.date, this.graphDataSales, 'date_sold', 'tamount')
        this.data.datasets[1].data = setMonthly(this.date, this.graphDataPurchases, 'date_recieved', 'tamount')
        this.data.datasets[2].data = setMonthly(this.date, this.graphDataLosts, 'date_lost', 'tamount')
        this.data.datasets[3].data = setMonthly(this.date, this.graphDataLoanTxn, 'date_transaction', 'tamount')
        this.data.datasets[4].data = setMonthly(this.date, this.graphDataLoanInv, 'date_loaned', 'tamount')
        this.data.datasets[5].data = setMonthly(this.date, this.graphDataExpense, 'date', 'tamount')
      },
      setDataYearly () {
        this.data.datasets[0].data = setYearly(this.date, this.graphDataSales, 'tamount')
        this.data.datasets[1].data = setYearly(this.date, this.graphDataPurchases, 'tamount')
        this.data.datasets[2].data = setYearly(this.date, this.graphDataLosts, 'tamount')
        this.data.datasets[3].data = setYearly(this.date, this.graphDataLoanTxn, 'tamount')
        this.data.datasets[4].data = setYearly(this.date, this.graphDataLoanInv, 'tamount')
        this.data.datasets[5].data = setYearly(this.date, this.graphDataExpense, 'tamount')
      },
      setLabelsWeekly () {
        this.data.labels = getWeekly(this.date)
      },
      setLabelsMonthly () {
        this.data.labels = getMonthly(this.date)
      },
      setLabelsYearly () {
        this.data.labels = getYearly(this.date)
      },
    },
  }
</script>
